import api from '@/api'


const state = {
  recursoRecursoTipo: []
}

const getters = {
  recursoRecursoTipo: (state) => {
    return state.recursoRecursoTipo
  }
}

const mutations = {
  SET_RECURSO_RECURSO_TIPO(state, recursoRecursoTipo) {
    state.recursoRecursoTipo = recursoRecursoTipo
  }
}

const actions = {
  async fetchRecursoRecursoTipo({ commit }) {
    try {
      const response = await api.recursoRecursoTipo.getRecursoRecursoTipo()
      commit('SET_RECURSO_RECURSO_TIPO', response.data)

    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
